// extracted by mini-css-extract-plugin
export default {"bg":"z+6v-lYNXhw+MX53mpl4Rw=="};